const resetCpfCnpjInput = (validation) => {
  if (validation.values.cpfInput) {
    validation.handleChange({
      target: {
        name: 'cpfInput',
        value: '',
      },
    });
  }
};

export { resetCpfCnpjInput };
